export default "/images/alka.avif?9503386e7c04835d904027a285dde220";